/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdresseDto } from './AdresseDto';
import {
    AdresseDtoFromJSON,
    AdresseDtoFromJSONTyped,
    AdresseDtoToJSON,
} from './AdresseDto';
import type { CompteBancaireDto } from './CompteBancaireDto';
import {
    CompteBancaireDtoFromJSON,
    CompteBancaireDtoFromJSONTyped,
    CompteBancaireDtoToJSON,
} from './CompteBancaireDto';

/**
 * 
 * @export
 * @interface TuteurLieuDoublonGridDto
 */
export interface TuteurLieuDoublonGridDto {
    /**
     * 
     * @type {number}
     * @memberof TuteurLieuDoublonGridDto
     */
    idTuteurLieu?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurLieuDoublonGridDto
     */
    idtuteur?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof TuteurLieuDoublonGridDto
     */
    dateCv?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonGridDto
     */
    anneesExperience?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonGridDto
     */
    tutorat?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonGridDto
     */
    vdc?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonGridDto
     */
    derogation?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonGridDto
     */
    idresponsableDerogation?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TuteurLieuDoublonGridDto
     */
    dateDerogation?: Date | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof TuteurLieuDoublonGridDto
     */
    idmetiers?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurLieuDoublonGridDto
     */
    idpersonne?: number;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonGridDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonGridDto
     */
    prenom?: string | null;
    /**
     * 
     * @type {AdresseDto}
     * @memberof TuteurLieuDoublonGridDto
     */
    adresseDto?: AdresseDto;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonGridDto
     */
    readonly adresse?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonGridDto
     */
    readonly codePostal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonGridDto
     */
    readonly localite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonGridDto
     */
    nationalite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonGridDto
     */
    codePaysNaissance?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TuteurLieuDoublonGridDto
     */
    dateNaissance?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonGridDto
     */
    registreNational?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonGridDto
     */
    numeroIdentification?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonGridDto
     */
    codesexe?: string | null;
    /**
     * 
     * @type {CompteBancaireDto}
     * @memberof TuteurLieuDoublonGridDto
     */
    compteBancaire?: CompteBancaireDto;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonGridDto
     */
    beid?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonGridDto
     */
    beidnumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonGridDto
     */
    remarque?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TuteurLieuDoublonGridDto
     */
    dateDeces?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonGridDto
     */
    localiteNaissance?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonGridDto
     */
    communeNaissance?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonGridDto
     */
    isApprenant?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonGridDto
     */
    isFormateur?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonGridDto
     */
    isRepresentant?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonGridDto
     */
    isTuteur?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonGridDto
     */
    isChefEntreprise?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonGridDto
     */
    isCollaborateur?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonGridDto
     */
    isDelegueTutelle?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonGridDto
     */
    isConseillePedagogique?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonGridDto
     */
    isContact?: boolean;
}

/**
 * Check if a given object implements the TuteurLieuDoublonGridDto interface.
 */
export function instanceOfTuteurLieuDoublonGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TuteurLieuDoublonGridDtoFromJSON(json: any): TuteurLieuDoublonGridDto {
    return TuteurLieuDoublonGridDtoFromJSONTyped(json, false);
}

export function TuteurLieuDoublonGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuteurLieuDoublonGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idTuteurLieu': !exists(json, 'idTuteurLieu') ? undefined : json['idTuteurLieu'],
        'idtuteur': !exists(json, 'idtuteur') ? undefined : json['idtuteur'],
        'dateCv': !exists(json, 'dateCv') ? undefined : (json['dateCv'] === null ? null : new Date(json['dateCv'])),
        'anneesExperience': !exists(json, 'anneesExperience') ? undefined : json['anneesExperience'],
        'tutorat': !exists(json, 'tutorat') ? undefined : json['tutorat'],
        'vdc': !exists(json, 'vdc') ? undefined : json['vdc'],
        'derogation': !exists(json, 'derogation') ? undefined : json['derogation'],
        'idresponsableDerogation': !exists(json, 'idresponsableDerogation') ? undefined : json['idresponsableDerogation'],
        'dateDerogation': !exists(json, 'dateDerogation') ? undefined : (json['dateDerogation'] === null ? null : new Date(json['dateDerogation'])),
        'idmetiers': !exists(json, 'idmetiers') ? undefined : json['idmetiers'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'adresseDto': !exists(json, 'adresseDto') ? undefined : AdresseDtoFromJSON(json['adresseDto']),
        'adresse': !exists(json, 'adresse') ? undefined : json['adresse'],
        'codePostal': !exists(json, 'codePostal') ? undefined : json['codePostal'],
        'localite': !exists(json, 'localite') ? undefined : json['localite'],
        'nationalite': !exists(json, 'nationalite') ? undefined : json['nationalite'],
        'codePaysNaissance': !exists(json, 'codePaysNaissance') ? undefined : json['codePaysNaissance'],
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : (json['dateNaissance'] === null ? null : new Date(json['dateNaissance'])),
        'registreNational': !exists(json, 'registreNational') ? undefined : json['registreNational'],
        'numeroIdentification': !exists(json, 'numeroIdentification') ? undefined : json['numeroIdentification'],
        'codesexe': !exists(json, 'codesexe') ? undefined : json['codesexe'],
        'compteBancaire': !exists(json, 'compteBancaire') ? undefined : CompteBancaireDtoFromJSON(json['compteBancaire']),
        'beid': !exists(json, 'beid') ? undefined : json['beid'],
        'beidnumber': !exists(json, 'beidnumber') ? undefined : json['beidnumber'],
        'remarque': !exists(json, 'remarque') ? undefined : json['remarque'],
        'dateDeces': !exists(json, 'dateDeces') ? undefined : (json['dateDeces'] === null ? null : new Date(json['dateDeces'])),
        'localiteNaissance': !exists(json, 'localiteNaissance') ? undefined : json['localiteNaissance'],
        'communeNaissance': !exists(json, 'communeNaissance') ? undefined : json['communeNaissance'],
        'isApprenant': !exists(json, 'isApprenant') ? undefined : json['isApprenant'],
        'isFormateur': !exists(json, 'isFormateur') ? undefined : json['isFormateur'],
        'isRepresentant': !exists(json, 'isRepresentant') ? undefined : json['isRepresentant'],
        'isTuteur': !exists(json, 'isTuteur') ? undefined : json['isTuteur'],
        'isChefEntreprise': !exists(json, 'isChefEntreprise') ? undefined : json['isChefEntreprise'],
        'isCollaborateur': !exists(json, 'isCollaborateur') ? undefined : json['isCollaborateur'],
        'isDelegueTutelle': !exists(json, 'isDelegueTutelle') ? undefined : json['isDelegueTutelle'],
        'isConseillePedagogique': !exists(json, 'isConseillePedagogique') ? undefined : json['isConseillePedagogique'],
        'isContact': !exists(json, 'isContact') ? undefined : json['isContact'],
    };
}

export function TuteurLieuDoublonGridDtoToJSON(value?: TuteurLieuDoublonGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idTuteurLieu': value.idTuteurLieu,
        'idtuteur': value.idtuteur,
        'dateCv': value.dateCv === undefined ? undefined : (value.dateCv === null ? null : value.dateCv.toISOString()),
        'anneesExperience': value.anneesExperience,
        'tutorat': value.tutorat,
        'vdc': value.vdc,
        'derogation': value.derogation,
        'idresponsableDerogation': value.idresponsableDerogation,
        'dateDerogation': value.dateDerogation === undefined ? undefined : (value.dateDerogation === null ? null : value.dateDerogation.toISOString()),
        'idmetiers': value.idmetiers,
        'idpersonne': value.idpersonne,
        'nom': value.nom,
        'prenom': value.prenom,
        'adresseDto': AdresseDtoToJSON(value.adresseDto),
        'nationalite': value.nationalite,
        'codePaysNaissance': value.codePaysNaissance,
        'dateNaissance': value.dateNaissance === undefined ? undefined : (value.dateNaissance === null ? null : value.dateNaissance.toISOString()),
        'registreNational': value.registreNational,
        'numeroIdentification': value.numeroIdentification,
        'codesexe': value.codesexe,
        'compteBancaire': CompteBancaireDtoToJSON(value.compteBancaire),
        'beid': value.beid,
        'beidnumber': value.beidnumber,
        'remarque': value.remarque,
        'dateDeces': value.dateDeces === undefined ? undefined : (value.dateDeces === null ? null : value.dateDeces.toISOString()),
        'localiteNaissance': value.localiteNaissance,
        'communeNaissance': value.communeNaissance,
        'isApprenant': value.isApprenant,
        'isFormateur': value.isFormateur,
        'isRepresentant': value.isRepresentant,
        'isTuteur': value.isTuteur,
        'isChefEntreprise': value.isChefEntreprise,
        'isCollaborateur': value.isCollaborateur,
        'isDelegueTutelle': value.isDelegueTutelle,
        'isConseillePedagogique': value.isConseillePedagogique,
        'isContact': value.isContact,
    };
}

